// extracted by mini-css-extract-plugin
export default {"label":"IntentionToSell-module__label--sTQkT"};